/* YOUY – protótipo Figma (out/2026): banner da home sob o cabeçalho de vidro, "+" dos atalhos no mobile e link do provador na PDP */
(function(){
  function pull(){
    var main=document.querySelector('main[data-template="index"]'); if(!main) return;
    var group=document.getElementById('header-group'); if(!group) return;
    /* #header-group usa display:contents, então mede os filhos */
    var ann=group.querySelector('.announcement-bar');
    var annSec=ann ? ann.closest('.shopify-section') || ann : null;
    var top=annSec ? annSec.getBoundingClientRect().bottom : 0;
    var bottom=top;
    Array.prototype.forEach.call(group.children,function(el){
      if(el===annSec || el.tagName==='SCRIPT' || el.offsetParent===null) return;
      bottom=Math.max(bottom, el.getBoundingClientRect().bottom);
    });
    var v=Math.max(0, Math.round(bottom-top));
    document.body.style.setProperty('--yy-hero-pull', v+'px');
  }
  function navMore(){
    var nav=document.querySelector('.yz-mobile-nav'); if(!nav) return;
    var btn=nav.querySelector('.yz-mobile-nav__more'); if(!btn || btn.dataset.on) return; btn.dataset.on='1';
    btn.addEventListener('click',function(){
      var open=!nav.classList.contains('is-open');
      nav.classList.toggle('is-open',open);
      btn.setAttribute('aria-expanded',open?'true':'false');
    });
  }
  /* PDP: link "provador virtual" abre o provador da FittingBox quando a cor tem modelo 3D */
  document.addEventListener('click',function(e){
    var a=e.target.closest && e.target.closest('[data-yy-vto]'); if(!a || e.defaultPrevented) return;
    var t=document.querySelector('[data-fb-vto-trigger]:not([hidden]) .fitting-box-vto-button');
    if(t){ e.preventDefault(); t.click(); }
  });
  /* logo maior (CSS): troca a imagem por uma versão em alta para não ficar borrada */
  function logoHiRes(){
    var i=document.querySelector('header-component .header-logo__image'); if(!i || i.dataset.yyHi) return; i.dataset.yyHi='1';
    var src=i.getAttribute('src')||''; if(src.indexOf('height=')<0) return;
    var u=function(h){ return src.replace(/height=\d+/, 'height='+h); };
    i.setAttribute('srcset', u(110)+' 1x, '+u(220)+' 2x, '+u(330)+' 3x');
    i.setAttribute('src', u(220));
  }
  function boot(){ logoHiRes(); if(window.scrollY<5) pull(); navMore(); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  window.addEventListener('load',function(){ if(window.scrollY<5) pull(); });
  var t; window.addEventListener('resize',function(){ clearTimeout(t); t=setTimeout(function(){ if(window.scrollY<5) pull(); },150); });
})();
